// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This CSS file styles the AI Influencer form page, including layout, spacing, and responsive design for the form and its fields. */
.MuiGrid-root.influencerFormContainer {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 100vh;
  padding: 0px 30px;
}

.MuiGrid-root.studioNavForm {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 40px;
}

.MuiBox-root.studioNavFormButtonBox {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  width: 100%;
  gap: 10px;
}

.MuiTypography-root.influenceTitle {
  font-family: var(--font-family-primary);
  font-weight: 400;
  font-size: 20px;
  color: #EBEBF5;
  display: flex;
  align-items: center;
}
.MuiTypography-root.influencerDescription{
  font-family: var(--font-family-primary);
  font-weight: 400;
  font-size: 14px;
  color: #EBEBF5;
}

/* .MuiBox-root.influencerForm {
  border: 1px solid rgba(96, 88, 105, 1);
  border-radius: 10px;
  padding: 10px;
} */

.MuiBox-root.influencerForm>*+* {
  margin-top: 14px;
}

.MuiFormControl-root.MuiTextField-root.textField.width-full {
  width: 100%;
}

/* ShowCaseModalDetails.css */

.showCaseAddModelContainer {
  width: 100%;
}

.showcase-header {
  display: flex;
  flex-direction: row;
  padding: 0px 0px 0px 10px;
  gap: 10px;
  align-items: center;
  margin: 5px 0px;
  width: 100%;
}

.showcase-container {
  background-color: #1D1C34;
  height: 100%;
}

.MuiBox-root.tabs-container {
  flex-grow: 1;
  margin: 0 auto;
  padding: 0px 30px;
  border-bottom: 1px solid #565A78;
  display: flex;
  justify-content: space-between;
}

.tabs-style .MuiTabs-flexContainer {
  min-height: 60px;
  border-bottom: 2px solid #565A78;
}

.tabs-style .MuiTabs-indicator {
  border: 1.5px solid #fff;
}

.MuiButtonBase-root.tab-style {
  color: #fff;
  font-size: 15px;
  text-transform: capitalize;
  font-weight: 600;
  font-family: var(--font-family-primary);
  height: 50px;
  min-height: 60px;
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.MuiBox-root.button-main {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
}

.MuiButtonBase-root.button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #69319D;
  color: #FDFCFF;
  border-radius: 10px;
  padding: 10px 26px;
  text-transform: none;
  width: 100%;
}

.MuiTypography.train-text {
  font-weight: 400;
  font-family: 'var(--font-family-primary)';
  font-size: 15px;
}

.MuiTypography-root.modal-name {
  color: #fff;
  font-size: 24px;
  font-weight: 400;
  font-family: 'var(--font-family-primary)';
}

.icon-button {
  color: #fff;
  display: flex;
}




/* Media Queries - 1024 */
@media screen and (min-width: 768px){
  .MuiBox-root.studioNavFormButtonBox {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
}

@media screen and (min-width: 1024px) {
  .MuiFormControl-root.MuiTextField-root.textField.width-full {
    width: 90%;
  }
.MuiBox-root.studioNavFormButtonBox {
    width: 70%;
  }

  .MuiBox-root.studioNavFormButtonBox {
    width: 90%;
  }
}


/* Media Queries - 1440 */
@media screen and (min-width: 1440px) {
  .MuiFormControl-root.MuiTextField-root.textField.width-full {
    width: 70%;
  }

  .MuiBox-root.studioNavFormButtonBox {
    width: 70%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Showcase/AIInfluencer.css"],"names":[],"mappings":"AAAA,oIAAoI;AACpI;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;;;GAIG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,6BAA6B;;AAE7B;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,uCAAuC;EACvC,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;;;;AAKA,yBAAyB;AACzB;EACE;EACA,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;;AAEA;EACE;IACE,UAAU;EACZ;AACF;IACI,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;;AAGA,yBAAyB;AACzB;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* This CSS file styles the AI Influencer form page, including layout, spacing, and responsive design for the form and its fields. */\n.MuiGrid-root.influencerFormContainer {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  min-height: 100vh;\n  padding: 0px 30px;\n}\n\n.MuiGrid-root.studioNavForm {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 40px;\n}\n\n.MuiBox-root.studioNavFormButtonBox {\n  display: flex;\n  flex-direction: column;\n  margin-top: 16px;\n  width: 100%;\n  gap: 10px;\n}\n\n.MuiTypography-root.influenceTitle {\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n  font-size: 20px;\n  color: #EBEBF5;\n  display: flex;\n  align-items: center;\n}\n.MuiTypography-root.influencerDescription{\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n  font-size: 14px;\n  color: #EBEBF5;\n}\n\n/* .MuiBox-root.influencerForm {\n  border: 1px solid rgba(96, 88, 105, 1);\n  border-radius: 10px;\n  padding: 10px;\n} */\n\n.MuiBox-root.influencerForm>*+* {\n  margin-top: 14px;\n}\n\n.MuiFormControl-root.MuiTextField-root.textField.width-full {\n  width: 100%;\n}\n\n/* ShowCaseModalDetails.css */\n\n.showCaseAddModelContainer {\n  width: 100%;\n}\n\n.showcase-header {\n  display: flex;\n  flex-direction: row;\n  padding: 0px 0px 0px 10px;\n  gap: 10px;\n  align-items: center;\n  margin: 5px 0px;\n  width: 100%;\n}\n\n.showcase-container {\n  background-color: #1D1C34;\n  height: 100%;\n}\n\n.MuiBox-root.tabs-container {\n  flex-grow: 1;\n  margin: 0 auto;\n  padding: 0px 30px;\n  border-bottom: 1px solid #565A78;\n  display: flex;\n  justify-content: space-between;\n}\n\n.tabs-style .MuiTabs-flexContainer {\n  min-height: 60px;\n  border-bottom: 2px solid #565A78;\n}\n\n.tabs-style .MuiTabs-indicator {\n  border: 1.5px solid #fff;\n}\n\n.MuiButtonBase-root.tab-style {\n  color: #fff;\n  font-size: 15px;\n  text-transform: capitalize;\n  font-weight: 600;\n  font-family: var(--font-family-primary);\n  height: 50px;\n  min-height: 60px;\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n}\n\n.MuiBox-root.button-main {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 30px;\n}\n\n.MuiButtonBase-root.button-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #69319D;\n  color: #FDFCFF;\n  border-radius: 10px;\n  padding: 10px 26px;\n  text-transform: none;\n  width: 100%;\n}\n\n.MuiTypography.train-text {\n  font-weight: 400;\n  font-family: 'var(--font-family-primary)';\n  font-size: 15px;\n}\n\n.MuiTypography-root.modal-name {\n  color: #fff;\n  font-size: 24px;\n  font-weight: 400;\n  font-family: 'var(--font-family-primary)';\n}\n\n.icon-button {\n  color: #fff;\n  display: flex;\n}\n\n\n\n\n/* Media Queries - 1024 */\n@media screen and (min-width: 768px){\n  .MuiBox-root.studioNavFormButtonBox {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n}\n}\n\n@media screen and (min-width: 1024px) {\n  .MuiFormControl-root.MuiTextField-root.textField.width-full {\n    width: 90%;\n  }\n.MuiBox-root.studioNavFormButtonBox {\n    width: 70%;\n  }\n\n  .MuiBox-root.studioNavFormButtonBox {\n    width: 90%;\n  }\n}\n\n\n/* Media Queries - 1440 */\n@media screen and (min-width: 1440px) {\n  .MuiFormControl-root.MuiTextField-root.textField.width-full {\n    width: 70%;\n  }\n\n  .MuiBox-root.studioNavFormButtonBox {\n    width: 70%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
